@use 'sass:string';
@use 'src/globals/main';

pn-modal .pn-modal {
  --pn-modal-max-width: 45em;
  --pn-modal-overflow: hidden auto;

  z-index: 10000;
  position: fixed;
  top: 0;
  inset-block-start: 0;
  inset-block-end: 0;
  margin: auto;

  overflow: var(--pn-modal-overflow);

  max-width: var(--pn-modal-max-width);
  max-height: 85vh;
  padding: clamp(1em, 5vw, 1.5em) 0;

  border: 0.0625em solid main.$gray50;
  border-radius: 0.5em;

  flex-direction: column;
  align-items: stretch;
  gap: 0.75em;

  box-shadow:
    0 0.25em 0.875em rgba(0, 0, 0, 0.18),
    0 1.625em 3.5em rgba(0, 0, 0, 0.22);
  background-color: main.$white;

  display: none;
  opacity: 0;
  transform: translate(0%, 20%);

  @include main.pn-focus(main.$white);
  @include main.pn-scrollbar;

  @include main.pn-transition('opacity, overlay, display, transform, outline-color', main.$timing-layout);
  transition-behavior: allow-discrete;

  &[data-sheet] {
    margin: 0 0 0 auto;
    height: 100%;
    max-height: unset;
    border-radius: 0.5em 0 0 0.5em;
    transform: translate(20%, 0%);
  }

  &[open] {
    display: flex;
    opacity: 1;
    transform: translate(0%, 0%);

    @starting-style {
      display: flex;
      opacity: 0;
      transform: translate(0%, 20%);
    }

    &[data-sheet] {
      transform: translate(0%, 0%);
      @starting-style {
        transform: translate(20%, 0%);
      }
    }
  }

  &::backdrop {
    background-color: rgba(main.$black, 0);

    @include main.pn-transition('opacity, background-color, overlay, display', main.$timing-layout);
    transition-behavior: allow-discrete;
  }

  &[open]::backdrop {
    background-color: rgba(main.$black, 0.55);
    @starting-style {
      background-color: rgba(main.$black, 0);
    }
  }

  &-close-button {
    position: absolute;
    right: 0.5em;
    top: 0.5em;
  }

  &-header {
    display: flex;
    flex-direction: column;
    gap: 0.5em;
    padding: 0 clamp(1em, 5vw, 1.5em);
  }

  &-label {
    line-height: 1.5;
    padding-right: 1.5em;
    margin: 0;
  }

  &-text {
    margin: 0;
  }

  &-content {
    padding: 0 clamp(1em, 5vw, 1.5em);
  }

  &-buttons {
    background-color: main.$white;
    border-top: 0.0625em solid main.$gray200;
    padding: clamp(1em, 5vw, 1.5em) clamp(1em, 5vw, 1.5em) 0;
    display: flex;
    justify-content: flex-end;
    gap: 0.5em;
    [slot='buttons']:not(pn-button) {
      display: flex;
      justify-content: flex-end;
      gap: 0.5em;
    }
    &:empty {
      display: none;
    }
  }
}

@media (max-width: 30em) {
  pn-modal .pn-modal {
    width: 100%;
    max-height: 95vh;
    margin-bottom: 0;
    bottom: 0;
    transform: translate(0%, 20%);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}
